export { default } from './TeamChatMemberAvatar';
